import ProductSalesModule from "./productSalesModule";
import ProductSalesSaga from "./redux/productSalesSagas";
import ProductSalesReducer from "./redux/productSalesReducer";

export default {
  Component: ProductSalesModule,
  moduleName: "productSales",
  saga: ProductSalesSaga(),
  reducer: ProductSalesReducer
};
